import styles from 'css/src/components/common/mentions/ReferenceMention.module.scss';

import React from 'react';

import { KIND_ICON } from './referenceKinds';
import type { Reference } from './ReferenceMentionNode';

// Referenced statically, so the unused-class check can see them.
const THUMB_CLASS = styles['reference-menu-item__thumb'];
const PLACEHOLDER_CLASS = styles['reference-menu-item__thumb-placeholder'];
const SWATCHES_CLASS = styles['reference-menu-item__swatches'];

interface ReferenceRowIconProps {
    reference: Reference;
    isPlaying?: boolean;
    onTogglePreview?: () => void;
}

/** For a voice with a sample the icon doubles as a preview button. */
const ReferenceRowIcon: React.FC<ReferenceRowIconProps> = ({
    reference,
    isPlaying = false,
    onTogglePreview,
}) => {
    const { kind, name, thumbUrl, swatches, previewUrl } = reference;

    if (kind === 'voice' && previewUrl && onTogglePreview) {
        return (
            <button
                type="button"
                className={`${PLACEHOLDER_CLASS} ${styles['reference-preview-button']}`}
                // Keep focus where it was so the editor's blur doesn't close
                // the menu before the click registers.
                onMouseDown={(event) => event.preventDefault()}
                onClick={(event) => {
                    // Previewing a voice is not picking it.
                    event.stopPropagation();
                    onTogglePreview();
                }}
                aria-label={`${isPlaying ? 'Stop' : 'Play'} ${name} preview`}
            >
                <i className="material-symbols-outlined">{isPlaying ? 'stop' : 'play_arrow'}</i>
            </button>
        );
    }

    if (thumbUrl) {
        return <img className={THUMB_CLASS} src={thumbUrl} alt="" />;
    }

    if (swatches?.length) {
        return (
            <span className={SWATCHES_CLASS}>
                {swatches.slice(0, 4).map((color, index) => (
                    // Colours have no stable id and can repeat within a kit.
                    <span key={`${color}-${index}`} style={{ backgroundColor: color }} />
                ))}
            </span>
        );
    }

    return (
        <span className={PLACEHOLDER_CLASS}>
            <i className="material-symbols-outlined">{KIND_ICON[kind]}</i>
        </span>
    );
};

export default ReferenceRowIcon;
